import { CATEGORY_FAQS } from "./categoryFaqs.constants";
import { action } from "src/utils/requestActions";

export function requestCategoryFaqs(payload) {
  return action(CATEGORY_FAQS.REQUEST, payload);
}
